export default __webpack_public_path__ + "static/media/privacy_policy.6a961789.pdf";